import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-responsive-video',
  templateUrl: './responsiveVideo.component.html',
  styleUrls: ['./responsiveVideo.component.scss'],
})
export class ResponsiveVideoComponent implements OnInit {
  @Input() videoData: any;
  play!: string;
  private readonly THUMBNAIL_SIZES = [
    'maxresdefault',
    'sddefault',
    'mqdefault',
    'hqdefault',
    'default',
  ];

  overlayImage!: string;

  constructor() {}

  ngOnInit(): void {
    if (this.videoData.type === 'video') {
      const videoLink =
        this.videoData.text.indexOf('?autoplay=1&enablejsapi=1&rel=0') > 0
          ? this.videoData.text.replace('?autoplay=1&enablejsapi=1&rel=0', '')
          : this.videoData.text;
      const initSubstring = videoLink.search('embed/');
      this.overlayImage = `https://i.ytimg.com/vi/${videoLink.substring(
        initSubstring + 6,
      )}/maxresdefault.jpg`;
      this.videoData.text += '?autoplay=1&enablejsapi=1&rel=0';
    } else {
      this.play = this.videoData.type;
    }
  }

  youtube_check(e: any): void {
    const url = e.src;
    if (e.naturalWidth === 120 && e.naturalHeight === 90) {
      for (let i = 0, len = this.THUMBNAIL_SIZES.length - 1; i < len; i++) {
        if (url.indexOf(this.THUMBNAIL_SIZES[i]) > 0) {
          e.src = url.replace(
            this.THUMBNAIL_SIZES[i],
            this.THUMBNAIL_SIZES[i + 1],
          );
          break;
        }
      }
    }
  }

  playVideo(event?: any): void {
    this.play = this.videoData.type;
  }
}
